import React, { useState } from 'react'
import icon1 from '../../../images/ai_chat.png'
import icon2 from '../../../images/ai_chat2.png'
import icon3 from '../../../images/ai_chat3.png'
import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'


const EmpoweringSuccess = (props) => {
    const [isOpen, setOpen] = useState(false)
    return (

        <section className="empowering_success_section section_space">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="heading_block text-center">

                  <span className="sub_heading">WHAT WE DO</span>
                  <br/>
                  <br/>
                  <h2 className="heading_text mb-0">
                    Services
                  </h2>
                </div>
              </div>
            </div>
            <div className="row align-items-center">

              <div className="col-lg-12 col-md-12">
                <ul className='service_list'>
                  <li style={{backgroundColor: '#FFF3F7'}}>
                    <div className='service_box'>
                      <img src={icon1} alt="icon" />
                      <h4>AI SEO Agency <br/> (GEO & AEO)</h4>
                      <p>Dominate both Search and AI Answers with Generative Engine Optimization (GEO) and Answer Engine Optimization (AEO). Get cited by AI tools and Google while climbing search rankings.</p>
                      <Link to="/service" className='read_more'>Learn More &nbsp;<i className='fa-solid fa-arrow-right'></i></Link>
                      <Button className='read_more'>Book a Call</Button>
                    </div>
                  </li>
                  <li style={{backgroundColor: '#FFFCE7'}}>
                    <div className='service_box'>
                      <img src={icon2} alt="icon" />
                      <h4>B2B AI SEO <br/> Agency</h4>
                      <p>We help B2B companies capture high-intent leads with AI-driven SEO strategies. From programmatic SEO to entity optimization, we turn organic traffic into a qualified pipeline.</p>
                      <Link to="/service" className='read_more'>Learn More &nbsp;<i className='fa-solid fa-arrow-right'></i></Link>
                      <Button className='read_more'>Book a Call</Button>
                    </div>
                  </li>
                  <li style={{backgroundColor: '#F5FFED'}}>
                    <div className='service_box'>
                      <img src={icon3} alt="icon" />
                      <h4>SaaS AI SEO <br/> Agency</h4>
                      <p>Scale your SaaS growth with AI SEO built for Product led growth and enterprise solutions. Capture long-tail demand, win AI answer spots, and convert traffic into demo bookings and signups.</p>
                      <Link to="/service" className='read_more'>Learn More &nbsp;<i className='fa-solid fa-arrow-right'></i></Link>
                      <Button className='read_more'>Book a Call</Button>
                    </div>
                  </li>
                </ul>
              </div>
              
            </div>
          </div>
        </section>
    )
}

export default EmpoweringSuccess;